/** Format a number with thousand separators (en-US locale). Returns '—' for nullish/NaN. */
export function fmt(n, dp = 0) {
    if (n === null || n === undefined || Number.isNaN(n))
        return '—';
    return Number(n).toLocaleString('en-US', {
        minimumFractionDigits: dp,
        maximumFractionDigits: dp,
    });
}
/** Abbreviate large numbers with Thai units ('พันล้าน' / 'ล้าน') or 'K'. */
export function fmtB(n) {
    if (n >= 1e9)
        return (n / 1e9).toFixed(2) + ' พันล้าน';
    if (n >= 1e6)
        return (n / 1e6).toFixed(2) + ' ล้าน';
    if (n >= 1e3)
        return (n / 1e3).toFixed(1) + 'K';
    return fmt(n);
}
/** Format a date as Thai short form e.g. '12 พ.ค. 26'. Returns '—' for nullish. */
export function fmtDate(s) {
    if (s === null || s === undefined || s === '')
        return '—';
    const d = s instanceof Date ? s : new Date(s);
    return d.toLocaleDateString('th-TH', {
        day: '2-digit',
        month: 'short',
        year: '2-digit',
    });
}
const TH_MONTHS_ABBR = [
    'ม.ค.',
    'ก.พ.',
    'มี.ค.',
    'เม.ย.',
    'พ.ค.',
    'มิ.ย.',
    'ก.ค.',
    'ส.ค.',
    'ก.ย.',
    'ต.ค.',
    'พ.ย.',
    'ธ.ค.',
];
/**
 * Format a date in Buddhist era (พ.ศ. = Gregorian year + 543), full 4-digit year
 * e.g. '12 พ.ค. 2569'. Returns '—' for nullish/invalid. Pairs with `fmtDate` for a
 * per-user พ.ศ./ค.ศ. display toggle.
 */
export function thaiDate(s) {
    if (s === null || s === undefined || s === '')
        return '—';
    const d = s instanceof Date ? s : new Date(s);
    if (Number.isNaN(d.getTime()))
        return '—';
    return `${d.getDate()} ${TH_MONTHS_ABBR[d.getMonth()]} ${d.getFullYear() + 543}`;
}
/**
 * Coerce an API money value (Prisma Decimal serialises to string) to a number,
 * treating nullish as 0. Uses `Number(...)` semantics (NOT parseFloat) — this is
 * the canonical form that was copy-pasted across the web app's list/detail views.
 * For variants needing parseFloat / NaN passthrough, keep a local helper.
 */
export function toNumber(v) {
    if (v === null || v === undefined)
        return 0;
    return typeof v === 'string' ? Number(v) : v;
}
/**
 * Format a Date as a local `YYYY-MM-DD` string for an `<input type="date">` value.
 * Local-time (not UTC) — uses the date's own getFullYear/getMonth/getDate so the
 * input reflects the day the user sees, not a TZ-shifted one. Distinct from
 * `fmtDate` (th-TH display) and `thaiDate` (พ.ศ. display).
 */
export function dateToInputValue(d) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
//# sourceMappingURL=fmt.js.map